import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosTerraDoSolTurismo = {
    ...dadosAgenciaComum,
    id: 'terradosolturismo',
    nome: 'Terra do Sol Turismo',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NBDZ5H5']
};
